"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLOT_MANAGEMENT_REQUEST_EXAMPLES = exports.renewSlotRequestSchema = exports.releaseSlotRequestSchema = exports.holdSlotRequestSchema = exports.getAvailableSlotsRequestSchema = void 0;
/**
 * Request contracts for the 3 Slot Management endpoints named in this
 * stage's brief. Field shapes mirror
 * `SlotManagementApplicationService`'s own method input shapes
 * (backend, frozen, Stage 5B.4). `DetectSlotConflict`/
 * `ExpireSlotHold` have no contract yet — the brief names 3 items, not
 * 5; see `docs/APPOINTMENT-API-REVIEW.md`'s Technical Debt Register.
 */
const zod_1 = require("zod");
exports.getAvailableSlotsRequestSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    fromDate: zod_1.z.coerce.date(),
    toDate: zod_1.z.coerce.date(),
});
exports.holdSlotRequestSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    scheduledAt: zod_1.z.coerce.date(),
    durationMinutes: zod_1.z.number().int().positive(),
    patientId: zod_1.z.string().uuid().optional(),
    expiresInMs: zod_1.z.number().int().positive().optional(),
});
exports.releaseSlotRequestSchema = zod_1.z.object({
    holdId: zod_1.z.string().uuid(),
    holdToken: zod_1.z.string().min(1),
    doctorId: zod_1.z.string().uuid().optional(),
    scheduledAt: zod_1.z.coerce.date().optional(),
});
/**
 * Extends a hold's `expiresAt` without releasing/re-acquiring it (desk,
 * 2026-09-11) — a bill raised against a picked slot must not expire the hold
 * while payment is genuinely still in progress.
 */
exports.renewSlotRequestSchema = zod_1.z.object({
    holdId: zod_1.z.string().uuid(),
    holdToken: zod_1.z.string().min(1),
    expiresInMs: zod_1.z.number().int().positive().optional(),
});
exports.SLOT_MANAGEMENT_REQUEST_EXAMPLES = {
    getAvailableSlots: {
        doctorId: '22222222-2222-2222-2222-222222222222',
        branchId: '33333333-3333-3333-3333-333333333333',
        departmentId: '44444444-4444-4444-4444-444444444444',
        fromDate: new Date('2026-08-01'),
        toDate: new Date('2026-08-08'),
    },
    holdSlot: {
        doctorId: '22222222-2222-2222-2222-222222222222',
        branchId: '33333333-3333-3333-3333-333333333333',
        departmentId: '44444444-4444-4444-4444-444444444444',
        scheduledAt: new Date('2026-08-01T10:00:00Z'),
        durationMinutes: 15,
    },
    releaseSlot: {
        holdId: '60000000-0000-0000-0000-000000000001',
        holdToken: 'abcd1234efgh5678',
    },
};
//# sourceMappingURL=slot-management.request.js.map